import React from 'react';
import '../Css_files/Expert_tips.css';
import Footer from './Footer';
import Navbar from './Navbar';

const ExpertTips = () => {
  const fields = [
    {
      id: 'mechanical',
      title: 'Mechanical Engineering',
      icon: '⚙️',
      tips: [
        'Master CAD software like SolidWorks, AutoCAD, and CATIA',
        'Understand thermodynamics and fluid mechanics deeply',
        'Learn manufacturing processes and materials science',
        'Focus on problem-solving and analytical thinking',
        'Stay updated with Industry 4.0 technologies'
      ]
    },
    {
      id: 'civil',
      title: 'Civil Engineering',
      icon: '🏗️',
      tips: [
        'Learn structural analysis and design software (SAP2000, ETABS)',
        'Understand building codes and safety regulations',
        'Master project management and construction planning',
        'Focus on sustainable and green building practices',
        'Develop strong communication and leadership skills'
      ]
    },
    {
      id: 'ece',
      title: 'Electronics & Communication',
      icon: '📡',
      tips: [
        'Master circuit design and PCB layout tools',
        'Learn embedded systems and microcontroller programming',
        'Understand signal processing and communication protocols',
        'Focus on IoT and wireless technologies',
        'Practice with simulation software like MATLAB/Simulink'
      ]
    },
    {
      id: 'electronics',
      title: 'Electronics Engineering',
      icon: '🔌',
      tips: [
        'Learn analog and digital circuit design',
        'Master power electronics and control systems',
        'Understand semiconductor devices and their applications',
        'Focus on automation and robotics',
        'Stay updated with latest electronic components'
      ]
    },
    {
      id: 'computer',
      title: 'Computer Science',
      icon: '💻',
      tips: [
        'Master multiple programming languages (Python, Java, C++)',
        'Learn data structures and algorithms thoroughly',
        'Understand software development lifecycle',
        'Focus on emerging technologies (AI, ML, Blockchain)',
        'Build strong problem-solving and logical thinking'
      ]
    },
    {
      id: 'arts',
      title: 'Arts & Multimedia',
      icon: '🎨',
      tips: [
        'Master design software (Photoshop, Illustrator, After Effects)',
        'Understand color theory and composition principles',
        'Learn video editing and motion graphics',
        'Focus on user experience and interface design',
        'Build a strong portfolio showcasing diverse skills'
      ]
    }
  ];

  return (
    <>
    {/* <Navbar/> */}
    <div className="expert-tips-container">
      <header className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Expert Tips for Success</h1>
          <p className="hero-subtitle">
            Discover industry insights and expert advice to excel in your field
          </p>
        </div>
        <div className="hero-decoration"></div>
      </header>

      <main className="tips-grid">
        {fields.map((field, index) => (
          <div key={field.id} className="tip-card" style={{ animationDelay: `${index * 0.1}s` }}>
            <div className="card-header">
              <div className="field-icon">{field.icon}</div>
              <h2 className="field-title">{field.title}</h2>
            </div>
            <div className="card-body">
              <ul className="tips-list">
                {field.tips.map((tip, tipIndex) => (
                  <li key={tipIndex} className="tip-item">
                    <span className="tip-bullet">→</span>
                    <span className="tip-text">{tip}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </main>

      <section className="additional-content">
        <h2 className="section-title">Why These Tips Matter</h2>
        <div className="content-grid">
          <div className="content-card">
            <h3>Stay Competitive</h3>
            <p>Following expert advice helps you stay ahead in rapidly evolving industries</p>
          </div>
          <div className="content-card">
            <h3>Build Expertise</h3>
            <p>Focused learning in key areas builds deep expertise valued by employers</p>
          </div>
          <div className="content-card">
            <h3>Career Growth</h3>
            <p>Implementing these tips accelerates your professional development</p>
          </div>
        </div>
      </section>
    </div>
    {/* <Footer/> */}
    </>
  );
};

export default ExpertTips;